import React from 'react';
import PropTypes from 'prop-types';

import Velocity from 'velocity-animate';
export default class Subnav extends React.Component {
  static propTypes = {
    containsActive: PropTypes.bool,
    children: PropTypes.array,
  };

  // Settings are mostly here to manage all panel based transitions,
  // this includes wallpaper and transfer window move for full-panel.
  settings = {
    mobileHA: true,
    duration: 500, // .5s
    easing: [0.77, 0.0, 0.175, 1.0], // [cubic bezier]
  };

  componentDidMount() {
    if (!this.node) {
      return;
    }
    Velocity.hook(this.node, 'width', this.props.containsActive ? 'auto' : 0);
  }

  slideIn(complete) {
    if (!this.node) {
      return;
    }
    const currentValue = Velocity.hook(this.node, 'width');
    Velocity.hook(this.node, 'width', 'auto');

    const requiredValue = Velocity.hook(this.node, 'width');
    Velocity.hook(this.node, 'width', currentValue);

    Velocity(this.node, 'stop', true);
    Velocity(
      this.node,
      { width: requiredValue },
      {
        ...this.settings,
        complete,
      }
    );
  }

  slideOut(complete) {
    if (!this.node) {
      return;
    }
    Velocity(this.node, 'stop', true);
    Velocity(
      this.node,
      { width: '0px' },
      {
        ...this.settings,
        complete,
      }
    );
  }

  componentDidUpdate(prevProps) {
    if (!prevProps.containsActive && this.props.containsActive) {
      this.slideIn();
    } else if (prevProps.containsActive && !this.props.containsActive) {
      this.slideOut();
    }
  }

  render() {
    return (
      <ul ref={(node) => (this.node = node)} className="nav__subitems">
        {this.props.children}
      </ul>
    );
  }
}
